module.exports = __webpack_public_path__ + "static/media/left.1ef47038.png";